import React, { useContext } from "react";
import {
  AppBar,
  Box,
  IconButton,
  Stack,
  Toolbar,
  Typography,
  Tooltip,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import ColorModeContext from "../../context/ColorModeContext";

const Topbar = ({ drawerWidth, onMenuClick }) => {
  const { mode, toggleColorMode } = useContext(ColorModeContext);
  const navigate = useNavigate();

  return (
    <AppBar
      position="fixed"
      color="transparent"
      elevation={0}
      sx={{
        borderBottom: "1px solid",
        borderColor: "divider",
        backdropFilter: "blur(16px)",
        bgcolor: mode === "dark" ? "rgba(18, 18, 18, 0.9)" : "rgba(255, 255, 255, 0.9)",
        width: { md: `calc(100% - ${drawerWidth}px)` },
        ml: { md: `${drawerWidth}px` },
      }}
    >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between", py: 1 }}>
        <Stack direction="row" spacing={2} alignItems="center">
          <IconButton color="inherit" edge="start" onClick={onMenuClick} sx={{ display: { md: "none" } }}>
            <MenuIcon />
          </IconButton>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
              JobsYahan Admin
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Unified Operations Hub
            </Typography>
          </Box>
        </Stack>
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Tooltip title={mode === "dark" ? "Switch to light mode" : "Switch to dark mode"}>
            <IconButton color="inherit" onClick={toggleColorMode}>
              {mode === "dark" ? <LightModeIcon /> : <DarkModeIcon />}
            </IconButton>
          </Tooltip>
          <Tooltip title="Logout">
            <IconButton
              color="inherit"
              onClick={() => navigate("/logout")}
              sx={{
                bgcolor:
                  mode === "dark" ? "rgba(255, 140, 0, 0.14)" : "rgba(122, 75, 117, 0.12)",
                color: mode === "dark" ? "#ffb657" : "#7a4b75",
                "&:hover": {
                  bgcolor:
                    mode === "dark" ? "rgba(255, 140, 0, 0.22)" : "rgba(122, 75, 117, 0.2)",
                },
              }}
            >
              <LogoutIcon />
            </IconButton>
          </Tooltip>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default Topbar;
